var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./Order.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?{\"id\":\"data-v-772db23d\"}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./Order.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Order.vue
// module id = 178
// module chunks = 1